import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';
import { byRegion } from 'app/shared-components/region/byRegion';
import SupportDashboardLayout from './layouts/SupportDashboardLayout';

const LinkageRequestsTab = lazy(() => import('./use-cases/linkage-requests'));
const AllUsersTab = lazy(() => import('./use-cases/all-users'));
const EmailLogTab = lazy(() => import('./use-cases/email-log'));
const ReviewsTab = lazy(() => import('./use-cases/reviews'));

const reviewsRoute = { path: 'reviews', element: <ReviewsTab /> };

const tabRoutes = byRegion({
  uk: [reviewsRoute],
  canada: [
    { path: 'linkage-requests', element: <LinkageRequestsTab /> },
    { path: 'users', element: <AllUsersTab /> },
    { path: 'email-log', element: <EmailLogTab /> },
    reviewsRoute,
  ],
});

const defaultTabPath = tabRoutes[0].path;

const SupportDashboardConfig = {
  settings: {
    layout: {
      config: {
        footer: { display: false },
        healtheraHeader: { display: true },
      },
    },
  },
  auth: authRoles.support,
  routes: [
    {
      path: 'support-dashboard',
      element: <SupportDashboardLayout />,
      children: [
        { path: '', element: <Navigate to={defaultTabPath} replace /> },
        ...tabRoutes,
        { path: '*', element: <Navigate to={defaultTabPath} replace /> },
      ],
    },
  ],
};

export default SupportDashboardConfig;
